// Next patches history.replaceState into a router RESTORE that discards any in-flight navigation,
// so never "write" a URL that is already the current one. The state must be a fresh object: Next
// only syncs useSearchParams when the state lacks its own markers (window.history.state has them).
export const replaceUrlIfChanged = (searchParams: URLSearchParams) => {
  const query = searchParams.toString()
  const newUrl = query ? `${window.location.pathname}?${query}` : window.location.pathname
  if (newUrl === `${window.location.pathname}${window.location.search}`) return
  window.history.replaceState({}, '', newUrl)
}
